import React, { useEffect, useState } from 'react';
import { TextButton } from './Button';
import { IoIosCheckmark, IoIosClose } from 'react-icons/io';
import { AI_AGENT_ASSETS } from '../../config/defaultAssetUrls';
import { IoRefreshOutline } from 'react-icons/io5';

type AISuggestionProps = {
    onAccept?: () => void;
    onReject?: () => void;
    onRefresh?: () => void;
    isRefreshLoading?: boolean;
    children?: React.ReactNode;
    header?: string;
    sentences?: string[];
};



const AISuggestion: React.FC<AISuggestionProps> = ({
    onAccept,
    onReject,
    onRefresh,
    isRefreshLoading,
    children,
    header,
    sentences
}) => {
    const suggestions: string[] = [
        "Just a thought — take it if you like it",
        "A quick suggestion, use it if it fits",
        "Sharing an idea — feel free to use it",
        "Here’s a tip — feel free to skip it",
        "Just an idea",
        "Thought this might help",
        "Use this if it works for you",
        "Here’s a suggestion",
        "Tossing this out there",
        "Just a little idea",
        "A quick thought — see if it works for you",
        "Here's a note - use it if you want",
        "This might be helpful or might not",
        "Just offering this in case it’s useful",
        "Use this if it helps — no worries if not"
    ];

    const [suggestion, setSuggestion] = useState<string>();

    useEffect(() => {
        const phrasePool = sentences || suggestions;
        setSuggestion(phrasePool[Math.floor(Math.random() * phrasePool.length)]);
    }, []);

    const accept = () => {
        if (onAccept) {
            onAccept();
        }
    }

    const reject = () => {
        if (onReject) {
            onReject();
        }
    }
    return (

        <div>
            {/* Colorful box */}
            {header && <label className='text-primary-700'>{header}</label>}
            <div className='w-full p-0.5 rounded-lg bg-gradient-to-r from-primary-500 via-primary-700 to-primary-300'>
                <div>
                    <div className='px-2 py-1.5 bg-white/90 rounded-md'>
                        <div className='flex flex-row items-center justify-between'>
                            <div className='flex flex-row items-center gap-2'>
                                <img src={AI_AGENT_ASSETS.ARIELLE_AVATAR} className='rounded-full w-6 h-6' />
                                <p className='text-primary-700'>{suggestion}</p>
                            </div>
                            {onRefresh && <div className='flex flex-wrap gap-1 items-center hover:cursor-pointer text-primary-700 hover:text-primary-900 transition-all duration-300' onClick={!isRefreshLoading ? onRefresh : undefined}>
                                <IoRefreshOutline size={14} className={`${isRefreshLoading ? 'animate-spin' : ''}`} />
                                <p className=''>Refresh</p>
                            </div>}
                        </div>
                        {children}
                    </div>
                </div>
            </div>
            {/* Buttons */}
            {(onAccept || onReject) && <div className='flex flex-row items-center justify-end gap-2'>
                {onReject && <div
                    onClick={reject}
                    className='caption2 text-red-500 hover:text-red-700 cursor-pointer transition-all duration-300'
                >Reject</div>}
                {onAccept && <div
                    onClick={accept}
                    className='caption2 text-primary hover:text-primary-700 cursor-pointer transition-all duration-300'
                >Accept</div>}
            </div>}
        </div>


    )
};

export default AISuggestion;